// This module wires up the LEGACY translation system only: it registers the nested-object
// dictionary from `@chancenwerk/translation-data/translation-data.ts` with `@adornis/translation-core`'s
// `clientTranslator`. That dictionary is read via `Translator` / `TranslationController` / `translate(ns, key)`
// and still backs data-view CSV/Excel exports, `CapacityAPI`, documentation notes and the old `x-filter-editor`.
//
// The NEWER adornis components (e.g. the functional `FilterEditor` from `@adornis/filter/client/filter-editor.js`,
// `translateFieldNameParaglide`, ...) do NOT read this dictionary. They use inlang/paraglide messages compiled
// from `@chancenwerk/translation-data/src/localisation/messages/*.json`, provided per entrypoint via
// `provideGlobalContext(translationContext, m)` in `startup.ts`.
//
// The two catalogs are maintained by hand and are NOT generated from each other, so a string shown in both
// places (e.g. filter aspect operator labels) has to be edited in both. Neither system is deprecated.
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import * as trans from '@chancenwerk/translation-data/translation-data.js';

export const languages = {
  german: Language.GERMAN,
  english: Language.ENGLISH,
};

export const productFieldTranslation = trans.productFieldTranslation;
export const butFieldTranslation = trans.butFieldTranslation;
export const translationData = trans.translationData;

clientTranslator.updateDictionary(translationData, [Language.GERMAN, Language.ENGLISH]);

// in ChancenRaum, always use German
globalLanguageSubject.next(Language.GERMAN);
